import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  graphic: {
    padding: 30,
    overflow: 'auto',
  },
  customTooltip: {
    backgroundColor: 'white',
    width: 100,
    height: 100,
  },
  rootCard: {
    minWidth: 100,
  },
}))
